// import { WOW } from "wowjs";
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
// 兼容现代浏览器：wow.js 1.1.3 的 animationName 内部使用了已被废弃并移除的
// CSSStyleDeclaration.getPropertyCSSValue，且其 getComputedStyle 兜底函数依赖 this===window，
// 打包后（模块作用域内 this 不是 window）会抛 “Cannot set properties of undefined (setting 'getPropertyValue')”。
// 这里用标准 API 重写，绕过 vendorCSS 和损坏的兜底逻辑。
// WOW.prototype.animationName = function (box) {
// 	var name = '';
// 	try {
// 		name = window.getComputedStyle(box).getPropertyValue('animation-name');
// 	} catch (e) {
// 		name = '';
// 	}
// 	return name === 'none' ? '' : name;
// };
// 全局唯一的 WOW 实例。由于 mixin 会挂载到每一个组件上，
// 如果每个组件的 mounted 都 new 一个 WOW，会导致页面存在多个 WOW 实例，
// 每个实例都会给 .wow 元素追加一次动画类，从而出现同一个标签被反复添加 animated 样式的问题。
// let wowInstance = null;
// mixin主
export const mixin = {
	data(){
	    return {
	        wowInstance:'',
			// 上传
			uplink:'https://appapi.binli-logistics.com/app/storage/upload',
			// 默认图片
			imgDef1:'https://file.binli-logistics.com/static/icon70.png',
			imgDef2:'https://binli-logistics.oss-cn-guangzhou.aliyuncs.com/ylf9x92c6qmh1oyjsyzs.jpg',
	    }
	},
	computed: {
		...mapState('userMsg',['userInfo','token']),
	},
    methods:{
		// 提示
		Tips(message,type = 'success'){
			this.$message({
				showClose: true,
				message,
				type
			});
		},
		// 路由跳转
		link(url,query={}){
			this.$router.push({path:url,query});
		},
		// 返回
		back(){
			this.$router.back()
		},
		// 复制文字
		copy_txt(text) {
			if (navigator.clipboard) {
				navigator.clipboard.writeText(text).then(() => {
					this.$message.success('复制成功')
				})
			} else {
				const input = document.createElement('input')
				input.value = text
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success('复制成功')
			}
		},
		// 下载图片
		downloadImage() {
			const link = document.createElement('a');
			link.download = 'poster.png';
			link.href = this.posterUrl;
			link.click();
		},
    },
    //挂载完毕就执行
    mounted() {
		// if (!wowInstance) {
		// 	var options = {
		// 		boxClass:'wow',// default 在用户滚动时显示隐藏框的类名。
		// 		animateClass:'animate__animated',// animate.css v4 的基础动画类名是 animate__animated（v3 才是 animated）
		// 		offset:0,// default 定义浏览器视口底部与隐藏框顶部之间的距离。当用户滚动并达到此距离时，将显示隐藏框。
		// 		mobile:true,// default 在移动设备上打开/关闭 wow.js。
		// 		live:true,// default 持续检查页面上是否有新的 WOW 元素。
		// 	};
		// 	wowInstance = new WOW(options);
		// 	wowInstance.init();
		// }
		// this.wowInstance = wowInstance;
    },
}
// mixin次
export const shareData = {
    data(){
        return {
            x:10,
            y:20
        }
    }
}
